import { formatMoney } from './novicell_shopify-utility.js';
import { openUpsellDrawer } from './novicell_upsell-shared.js';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.js-open-upsell-drawer');
  if (!container) return;

  const moneyFormat = window.shopMoneyFormat;

  function initializeOptionEvents() {
    const optionSections = document.querySelectorAll('.upsell-drawer-material-selects-switch');
    optionSections.forEach(section => {
      const clickableElems = section.querySelectorAll('label, img');
      const valueSpan = section.querySelector('.seleceted-option-value');

      if (clickableElems.length > 0) {
        clickableElems[0].classList.add('active');
        if (valueSpan) valueSpan.textContent = clickableElems[0].getAttribute('data-option-value-name');
      }

      clickableElems.forEach(elem => {
        // <label> without `for` and <img> aren't focusable by default and
        // don't dispatch click on Enter/Space. Promote them so keyboard
        // users can reach and activate every variant option.
        if (!elem.hasAttribute('tabindex')) elem.setAttribute('tabindex', '0');
        if (!elem.hasAttribute('role')) elem.setAttribute('role', 'button');
        if (!elem.hasAttribute('aria-label')) {
          const name = elem.getAttribute('data-option-value-name') || elem.alt;
          if (name) elem.setAttribute('aria-label', name);
        }
        elem.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            elem.click();
          }
        });

        elem.addEventListener('click', () => {
          clickableElems.forEach(i => i.classList.remove('active'));
          elem.classList.add('active');
          if (valueSpan) valueSpan.textContent = elem.getAttribute('data-option-value-name');

          const selectedOptions = [];
          optionSections.forEach(sec => {
            const span = sec.querySelector('.seleceted-option-value');
            if (span?.textContent.trim()) selectedOptions.push(span.textContent.trim());
          });

          const matchedVariant = window.upsellProduct?.variants?.find(v =>
            selectedOptions.every((opt, i) => opt === v[`option${i + 1}`])
          );
          if (!matchedVariant) return;

          const priceLowered = document.querySelector('.upsell-drawer-price-lowered');
          if (priceLowered) priceLowered.textContent = formatMoney(matchedVariant.price, moneyFormat).replace(/,/g, '.');

          const priceRegular = document.querySelector('.upsell-drawer-price-regular');
          if (priceRegular) priceRegular.textContent = '';

          const priceSpan = document.querySelector('#upsell-drawer-add-to-cart span');
          if (priceSpan) priceSpan.textContent = formatMoney(matchedVariant.price, moneyFormat);

          document.getElementById('upsell-drawer-add-to-cart')?.setAttribute('data-product-id', matchedVariant.id);

          // Scroll gallery to matched image
          let matchedImage = null;
          document.querySelectorAll('.scroll-container img').forEach(img => {
            const opts = [img.getAttribute('option1') || '', img.getAttribute('option2') || '', img.getAttribute('option3') || ''];
            if (selectedOptions.every(opt => opts.includes(opt))) matchedImage = img;
          });
          matchedImage?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

          // Fetch delivery/stock status for selected variant (section rendering for lightweight fetch)
          fetch(`/products/${window.upsellProduct.handle}?variant=${matchedVariant.id}&section_id=complementary-stock-status`)
            .then(res => res.ok ? res.text() : Promise.reject())
            .then(html => {
              const stockStatus = new DOMParser().parseFromString(html, 'text/html').querySelector('stock-status');
              const deliveryEl = document.querySelector('.upsell-drawer-delivery');
              if (stockStatus && deliveryEl) deliveryEl.innerHTML = stockStatus.innerHTML;
            })
            .catch(err => console.error('Error:', err));
        });
      });
    });
  }

  function renderVariantOptions(product) {
    const optionsWrapper = document.querySelector('.upsell-drawer-material-selects');
    if (!optionsWrapper || !product.options) return;
    optionsWrapper.innerHTML = '';

    // Use pre-rendered swatch URLs from Liquid (same approach as PDP)
    let swatchData = {};
    try {
      const swatchEl = document.getElementById('complementary-swatch-data');
      if (swatchEl) swatchData = JSON.parse(swatchEl.textContent);
    } catch (e) { /* no swatch data available */ }

    product.options.forEach(option => {
      const switchDiv = document.createElement('div');
      switchDiv.className = 'upsell-drawer-material-selects-switch tw-font-secondary tw-mr-16';
      switchDiv.innerHTML = `
        <p class="tw-mb-3">
          <span class="option-name">${option.name}</span>:<span class="seleceted-option-value tw-font-normal tw-font-primary tw-leading-normal"></span>
        </p>
        <div class="upsell-drawer-material-selects-options tw-flex tw-flex-wrap"></div>
      `;
      const optionsContainer = switchDiv.querySelector('.upsell-drawer-material-selects-options');
      const optionSwatches = swatchData[option.name] || {};

      option.values.forEach(value => {
        const swatchUrl = optionSwatches[value];

        if (swatchUrl) {
          const img = document.createElement('img');
          img.className = 'tw-object-fill tw-cursor-pointer tw-border-0 tw-border-transparent tw-p-0 tw-transition-colors tw-duration-200 tw-ease-in-out tw-mr-3 tw-mb-3';
          img.alt = value;
          img.src = swatchUrl;
          img.setAttribute('data-option-value-name', value);
          optionsContainer.appendChild(img);
        } else {
          const label = document.createElement('label');
          label.textContent = value;
          label.setAttribute('data-option-value-name', value);
          label.className = 'tw-mr-3 tw-mb-3 tw-text-sm tw-text-center tw-cursor-pointer';
          optionsContainer.appendChild(label);
        }
      });

      optionsWrapper.appendChild(switchDiv);
    });
  }

  // Open drawer and populate with product data
  container.addEventListener('click', async (e) => {
    e.preventDefault();
    const handle = container.dataset.complementaryHandle;
    if (!handle) return;

    try {
      const response = await fetch(`/products/${handle}.json`);
      if (!response.ok) throw new Error('Failed to fetch product');
      const { product } = await response.json();
      if (!product) return;

      window.upsellProduct = product;

      // Gallery images with variant option attributes (use variant_ids for reliable matching)
      const galleryBody = document.querySelector('.upsell-gallery-body');
      if (galleryBody) {
        galleryBody.innerHTML = '';
        (product.images || []).forEach(image => {
          const src = typeof image === 'string' ? image : image.src;
          let option1 = '', option2 = '', option3 = '';
          const variantIds = image.variant_ids || [];
          if (variantIds.length > 0) {
            const variant = product.variants.find(v => variantIds.includes(v.id));
            if (variant) {
              option1 = variant.option1 || ''; option2 = variant.option2 || ''; option3 = variant.option3 || '';
            }
          }
          const img = document.createElement('img');
          img.src = src + '&width=308';
          img.alt = product.title || '';
          img.setAttribute('option1', option1);
          img.setAttribute('option2', option2);
          img.setAttribute('option3', option3);
          galleryBody.appendChild(img);
        });
      }

      // Title (split on comma)
      if (product.title) {
        const parts = product.title.split(',');
        const primary = document.querySelector('.upsell-primary-title');
        const secondary = document.querySelector('.upsell-secondary-title');
        if (primary) {
          primary.textContent = parts[0].trim();
          // Keep the heading out of the a11y tree until it actually has a title
          primary.hidden = !primary.textContent;
        }
        if (secondary) secondary.textContent = parts.length > 1 ? parts.slice(1).join(',').trim() : '';
      }

      // Price
      const firstVariant = product.variants?.[0];
      const price = firstVariant ? firstVariant.price : product.price;
      const priceLowered = document.querySelector('.upsell-drawer-price-lowered');
      if (priceLowered) priceLowered.textContent = formatMoney(price, moneyFormat).replace(/,/g, '.');
      const priceRegular = document.querySelector('.upsell-drawer-price-regular');
      if (priceRegular) priceRegular.textContent = '';

      // Vendor
      const vendorSpan = document.querySelector('.upsell-drawer-designer-span');
      if (vendorSpan) vendorSpan.textContent = product.vendor || '';

      // Variant options
      renderVariantOptions(product);

      // Description + link
      const descWrapper = document.querySelector('.upsell-drawer-product-description');
      if (descWrapper) {
        const link = descWrapper.querySelector('#see-full-product');
        descWrapper.querySelector('.complementary-description')?.remove();
        if (product.body_html && link) {
          const descEl = document.createElement('div');
          descEl.className = 'complementary-description';
          // Intentional: body_html is Shopify admin-managed content, considered trusted
          descEl.innerHTML = product.body_html;
          descWrapper.insertBefore(descEl, link);
        }
        if (link) link.href = `/products/${product.handle}`;
      }

      const titleLink = document.getElementById('upsell-drawer-title-link');
      if (titleLink && product.handle) titleLink.href = `/products/${product.handle}`;

      // Add to cart button
      const addToCartBtn = document.getElementById('upsell-drawer-add-to-cart');
      if (addToCartBtn && firstVariant) {
        addToCartBtn.setAttribute('data-product-id', firstVariant.id);
        addToCartBtn.style.display = 'flex';
        const span = addToCartBtn.querySelector('span');
        if (span) span.textContent = formatMoney(price, moneyFormat);
      }

      // Delivery status (section rendering for lightweight fetch)
      fetch(`/products/${product.handle}?section_id=complementary-stock-status`)
        .then(res => res.ok ? res.text() : Promise.reject())
        .then(html => {
          const stockStatus = new DOMParser().parseFromString(html, 'text/html').querySelector('stock-status');
          const deliveryEl = document.querySelector('.upsell-drawer-delivery');
          if (stockStatus && deliveryEl) deliveryEl.innerHTML = stockStatus.innerHTML;
        })
        .catch(err => console.error('Fetch error:', err));

      initializeOptionEvents();

      // Open drawer (also flips aria-hidden and focuses the close-btn).
      openUpsellDrawer();
    } catch (error) {
      console.error('Error opening upsell drawer:', error);
    }
  });

  // Add to cart handler
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.upsell-add-item-to-cart');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;

    const variantId = button.getAttribute('data-product-id');
    if (!variantId) { button.disabled = false; return; }

    (async () => {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        });
        if (!res.ok) throw new Error((await res.json()).description || res.statusText);
        await res.json();
        await refreshCartDrawer();
        await updateCartBubble();
      } catch (err) {
        console.error('Error:', err);
      } finally {
        button.disabled = false;
        document.querySelector('.drawer-upsell')?.classList.remove('active');
        document.documentElement.style.overflow = '';
      }
    })();
  });

  async function refreshCartDrawer() {
    try {
      const res = await fetch(`/?section_id=cart-drawer&timestamp=${Date.now()}`, {
        headers: { Accept: 'text/html', 'Cache-Control': 'no-cache' },
      });
      if (!res.ok) throw new Error('Sections fetch error');
      const html = await res.text();
      const current = document.querySelector('cart-drawer');
      if (!current) return;
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const next = temp.querySelector('cart-drawer');
      if (!next) return;
      current.innerHTML = next.innerHTML;
      Array.from(next.attributes).forEach(a => { if (a.name !== 'id') current.setAttribute(a.name, a.value); });
      if (typeof current.open === 'function') current.open();
      else { current.classList.add('active'); current.setAttribute('open', ''); }
      await updateCartBubble();
    } catch {
      const cd = document.querySelector('cart-drawer');
      if (cd) { if (typeof cd.open === 'function') cd.open(); else { cd.classList.add('active'); cd.setAttribute('open', ''); } }
    }
  }

  async function updateCartBubble() {
    try {
      const res = await fetch('/cart.js?' + Date.now());
      if (!res.ok) return;
      const data = await res.json();
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      let countDiv = bubble.querySelector('div > span[aria-hidden]');
      if (data.item_count > 0) {
        if (!countDiv) { countDiv = document.createElement('div'); countDiv.className = 'max-[990px]:tw-self-end'; bubble.appendChild(countDiv); }
        countDiv.innerHTML = `<span aria-hidden="true">(${data.item_count})</span><span class="visually-hidden">(${data.item_count} items)</span>`;
      } else if (countDiv) { countDiv.remove(); }
    } catch (err) { console.error('Error updating cart count:', err); }
  }
});
